module.exports = __webpack_public_path__ + "img/logo_desktop.55e020f1.svg";